import { useMemo } from 'react';
import { CHECKOUT_URL } from '../data/kit';

const TRACKING_KEYS = ['fbclid', 'gclid', 'ttclid', 'msclkid', 'gbraid', 'wbraid', 'sck', 'src'];

/** Checkout link that forwards UTM and ad click IDs from the current page URL. */
export function useCheckoutUrl(): string {
  return useMemo(() => {
    if (typeof window === 'undefined') return CHECKOUT_URL;
    const destination = new URL(CHECKOUT_URL);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (/^utm_/.test(key) || TRACKING_KEYS.includes(key)) {
        destination.searchParams.set(key, value);
      }
    });
    return window.location.origin === destination.origin
      ? destination.pathname + destination.search
      : destination.href;
  }, []);
}
